import { useToast } from "contexts/ToastContext";
import { useEffect, useRef, useState } from "react";
import { LoadingPageIcon } from "utils/constant";
import { useTranslation } from "react-i18next";

import { useParams } from "react-router-dom";
import { getStakeholder } from "services/getEmployees";
import { useAuth } from "contexts/AuthContext";
import RegistrarLegislativeDraft from "./registrarLegislativeDraft";
import { CanShow, LEGISLATIVE_DRAFTING_UI_RULES, TeamScope } from "utils/authRules";
import { getLawImplementation } from "services/lawImplementationService";
import LegalAwarenessCreationDetail from "./fragments/leftPanel";
import LegalAwarenessCreationRightPanel from "./fragments/rightPanel";
import { getLegalAwareness, getSingleLegalAwareness } from "services/legalAwarenessService";

const SingleLegalAwarenessCreation = () => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const [data, setData] = useState({
        isLoading: true, status: "", forward_status: "",
    });
    const { id } = useParams<{ id: string }>();
    const contextData = useAuth();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getSingleLegalAwareness(id || "");
                let user = null;
                if (response.requested_by_id && response.requested_by !== "internal") {
                    try {
                        user = await getStakeholder(response.requested_by_id, contextData.token || contextData?.user?.access_token || "");
                    } catch (err) {
                        console.error("Error fetching stakeholder:", err);
                        showToast(t("FailedToFetchStakeholder") || "Failed to fetch stakeholder", "error");
                    }
                }
                setData({
                    isLoading: false,
                    ...response,
                    requested_by_user: user,
                });
            } catch (error) {
                console.error("Error fetching legal research request:", error);
                showToast(t("FailedToFetchLegalResearchRequest") || "Failed to fetch legal research request.", "error");
                setData((prev) => ({ ...prev, isLoading: false }));
            }
        };

        fetchData();
    }, [id, contextData.token, contextData?.user?.access_token, showToast, t]);

    if (data.isLoading)
        return (
            <div className="flex justify-center items-center h-64">
                {LoadingPageIcon}
            </div>
        );

    // Prosecutor actions on this request go to its team leader only.
    return (
        <TeamScope team={(data as any)?.teams}>
            <>
                {CanShow(LEGISLATIVE_DRAFTING_UI_RULES.edit_reference_number.value, data?.status, data?.forward_status) ?
                    <RegistrarLegislativeDraft request={data} /> :
                    <div className="flex h-full bg-gray-100 p-2">
                        <LegalAwarenessCreationDetail request={data} />
                        <LegalAwarenessCreationRightPanel request={data} />
                    </div>
                }
            </>
        </TeamScope>
    );
};

export default SingleLegalAwarenessCreation;